"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_router_dom_1 = require("react-router-dom");

var react_jss_1 = __importDefault(require("react-jss"));

var color_1 = __importDefault(require("color"));

var styles = function styles(theme) {
  return {
    button: {
      display: 'block',
      // backgroundImage: 'linear-gradient(rgb(250, 125, 54), rgb(247, 107, 28))',
      backgroundColor: theme.accentColor,
      color: color_1.default(theme.accentColor).luminosity() > 0.6 ? '#333333' : '#EEEEEE',
      lineHeight: 1.5,
      borderRadius: 4,
      textDecoration: 'none',
      padding: '6px 12px',
      textAlign: 'center',
      fontSize: 16
    },
    disabled: {
      // backgroundImage: 'linear-gradient(rgb(189, 143, 117), rgb(176, 127, 99))',
      backgroundColor: color_1.default(theme.accentColor).desaturate(0.5).hsl().string(),
      cursor: 'default'
    }
  };
};

var Button = function Button(_a) {
  var to = _a.to,
      onClick = _a.onClick,
      disabled = _a.disabled,
      children = _a.children,
      classes = _a.classes,
      className = _a.className;
  var clickHandler = disabled ? function (e) {
    return e.preventDefault();
  } : onClick;

  var _className = (disabled ? [classes.button, classes.disabled, className] : [classes.button, className]).join(' ');

  if (to) {
    return react_1.default.createElement(react_router_dom_1.Link, {
      className: _className,
      to: to,
      onClick: clickHandler
    }, children);
  } else {
    return react_1.default.createElement("button", {
      className: _className,
      onClick: clickHandler,
      disabled: disabled
    }, children);
  }
};

exports.default = react_jss_1.default(styles)(Button);